import { render, staticRenderFns } from "./sidebarCategory.vue?vue&type=template&id=20c72e56&scoped=true&"
import script from "./sidebarCategory.vue?vue&type=script&lang=js&"
export * from "./sidebarCategory.vue?vue&type=script&lang=js&"
import style0 from "./sidebarCategory.vue?vue&type=style&index=0&id=20c72e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c72e56",
  null
  
)

export default component.exports